﻿﻿export interface IInvoiceLineItemReport {
    invoiceNumber: number;
    fee: number;
    change: number;
    id: number;
    centerId: number;
    invoiceDate: string;
    description: string;
    applyTo: number;
    applyToDescription: string;
    isCredit: boolean;
    amount: number;
}
